import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import type {
  SalesItemAttributes,
  SalesProps
} from '../../BattleReportComponent.types';
import {
  StyledLegend,
  StyledLegendTitle,
  StyledTotal,
  StyledTotalData,
  StyledTotalDataItem,
  StyledTotalDataItemTitle,
  StyledTotalDataItemValue,
  StyledTotalTitle,
  StyledWrapper
} from './BattleReportGoals.styled';
import GoalsChart from './GoalsChart';

const BattleReportGoals: React.FC<SalesProps> = ({ sales }) => {
  const { t } = useI18n('battle-report');
  const { locale } = useRouter();

  const totalSales = (
    year: number,
    properties: Array<keyof SalesItemAttributes>
  ): string => {
    let totalAmount = 0;
    sales.forEach((obj) => {
      if (obj.attributes.year === year) {
        properties.forEach((property) => {
          totalAmount = totalAmount + (obj.attributes[property] as number);
        });
      }
    });
    return totalAmount.toLocaleString(locale);
  };

  return (
    <StyledWrapper>
      <Heading2 editorial>{t('battle-report.objectives.title')}</Heading2>
      <StyledTotal>
        <StyledTotalTitle>
          {t('battle-report.objectives.total')}
        </StyledTotalTitle>
        <StyledTotalData>
          <StyledTotalDataItem>
            <StyledTotalDataItemTitle>
              {t('battle-report.objectives.sales')}
            </StyledTotalDataItemTitle>
            <StyledTotalDataItemValue>
              {totalSales(2023, ['sales', 'billing'])}€
            </StyledTotalDataItemValue>
          </StyledTotalDataItem>
        </StyledTotalData>
      </StyledTotal>
      <StyledLegend>
        <div>
          <StyledLegendTitle>
            <div className="sales"></div>
            <span>{t('battle-report.objectives.legend.sales.title')}</span>
          </StyledLegendTitle>
          <p>{t('battle-report.objectives.legend.sales.desc')}</p>
        </div>
        <div>
          <StyledLegendTitle>
            <div className="turnover"></div>
            <span>{t('battle-report.objectives.legend.turnover.title')}</span>
          </StyledLegendTitle>
          <p>{t('battle-report.objectives.legend.turnover.desc')}</p>
        </div>
      </StyledLegend>
      <GoalsChart sales={sales} />
    </StyledWrapper>
  );
};

export default BattleReportGoals;
